









































import Vue from 'vue';
import { OpenManageCrossoverScreen } from '@/mixins/get-content-mixins';
import { ExtendMixins } from '@/services';
import { MemberPaymentMethodsResponseModel } from '@/@types/member';
import moment from 'moment';

export default ExtendMixins(
  OpenManageCrossoverScreen,
).extend({
  name: 'CrossoverPaymentMethod',
  props: {
    medicalCrossover: {
      type: Boolean,
      default: false,
    },
    ptpCrossover: {
      type: Boolean,
      default: false,
    },
    dentalCrossover: {
      type: Boolean,
      default: false,
    },
    hasPrimaryCardholder: {
      type: Boolean,
      required: true,
    },
    doNotAllowOptOut: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    crossoverElections(): string {
      const options = [];
      let text = '';

      if (this.medicalCrossover) {
        options.push(
          this.$options.filters.t([
            'manage-crossover_title_medical',
            'global_medical',
          ]),
        );
      }
      if (this.dentalCrossover) {
        options.push(
          this.$options.filters.t([
            'manage-crossover_title_dental',
            'global_dental',
          ]),
        );
      }
      if (this.ptpCrossover) {
        options.push(
          this.$options.filters.t([
            'manage-crossover_title_ptp',
            'global_pay-the-provider',
          ]),
        );
      }

      const length = options.length;
      options.forEach((option, index) => {
        if (index !== length - 1) {
          text += `${option}, `;
        } else {
          if (length > 2) {
            text += `and ${option}`;
          } else {
            text += option;
          }
        }
      });
      return text;
    },
    paymentMethods(): MemberPaymentMethodsResponseModel {
      return this.$store.getters.paymentMethods;
    },
    beforeStopCardDate(): boolean {
      const stopCardDate = this.paymentMethods ? moment(this.paymentMethods.stopCardDate) : '';
      const today = moment().startOf('day');
      return stopCardDate ? stopCardDate.isSameOrAfter(today) : false;
    },
    showSwitchToCrossoverButton(): boolean {
      return (
        this.hasPrimaryCardholder &&
        !this.medicalCrossover &&
        !this.dentalCrossover &&
        this.beforeStopCardDate
      );
    },
    showIfAllowsOptOutAndDoesNotHavePrimaryCardholderOrHasMedicalOrDentalCrossover(): boolean {
      /* BR-1.06 – The System will include a Make Changes button within the Crossover section of the screen
      if the System determines the Crossover section of the screen is not suppressed (per BR-1.03)
      and <DoNotAllowOptOut> is equal to false and either the Actor does not have a primary cardholder (per BR-1.04.b)
      or the <MedicalCrossoverElection> is equal to true or the <DentalCrossoverElection> is equal to true. */
      return (
        !this.doNotAllowOptOut &&
        (!this.hasPrimaryCardholder ||
          (this.medicalCrossover || this.dentalCrossover))
      );
    },
    suppressIfDoesNotAllowOptOutAndHasMedicalButNotDental(): boolean {
      /* BR-1.06.a – The System will suppress the Make Changes button within the Crossover section of the screen
      if the <DoNotAllowOptOut> is equal to true and the <MedicalCrossoverElection> is equal to true
      and the <DentalCrossoverElection> is equal to false. */
      return (
        this.doNotAllowOptOut && this.medicalCrossover && !this.dentalCrossover
      );
    },
    showIfDoesNotAllowOptOutAndHasDental(): boolean {
      /* BR-1.06.b – The system will display the Make Changes button within the Crossover section of the screen
      if the <DoNotAllowOptOut> is equal to true and the <DentalCrossoverElection> is equal to true. */
      return this.doNotAllowOptOut && this.dentalCrossover;
    },
    showMakeChangesButton(): boolean {
      if (
        this
          .showIfAllowsOptOutAndDoesNotHavePrimaryCardholderOrHasMedicalOrDentalCrossover ||
        this.showIfDoesNotAllowOptOutAndHasDental
      ) {
        return true;
      } else if (this.suppressIfDoesNotAllowOptOutAndHasMedicalButNotDental) {
        return false;
      }
    },
  },
});
